import { render, staticRenderFns } from "./KeyValueCell.vue?vue&type=template&id=bf034fe6&scoped=true&"
import script from "./KeyValueCell.vue?vue&type=script&lang=js&"
export * from "./KeyValueCell.vue?vue&type=script&lang=js&"
import style0 from "./KeyValueCell.vue?vue&type=style&index=0&id=bf034fe6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf034fe6",
  null
  
)

export default component.exports